<div class="relative w-full" #inputContainer>
   
    <!-- MAIN INPUT FIELD -->
    <input
        [type]="type"
        [disabled]="disabled"
        [placeholder]="placeholder"
        [class]="cssClass"
        [value]="inputValue"
        (input)="onInputChange($event)"
        (keydown)="onKeyDown($event)"
        (focus)="onFocus()"
        #inputField
    >
    
    <!-- RESULTS CONTAINER -->
    @if(openResults){

        <!-- CARET (desktop only) -->
        <div class="hidden lg:block absolute left-1/2 top-full mt-4 -translate-x-1/2 -translate-y-1/2 w-3 h-3 rotate-45 bg-white z-20"></div>

        <div
            class="absolute bottom-[36px] lg:bottom-auto lg:top-full lg:mt-4 left-0 z-10 w-full rounded-2xl bg-white shadow-md overflow-hidden"
            tabindex="-1"
            role="listbox"
        >
            <ul class="options-list px-2 py-2 max-h-60 overflow-y-auto">

                @for (option of filteredOptions; track option.value){

                    <li
                        (click)="selectOption(option)"
                        (keypress.enter)="selectOption(option)"
                        (mouseover)="hoverOption(option)"
                        (focus)="hoverOption(option)"
                        class="px-3 py-2.5 cursor-pointer rounded-lg text-sm font-semibold text-gray-800 hover:bg-black/5"
                        [class]="{'bg-black/5': highlightedIndex === filteredOptions.indexOf(option)}"
                        role="option"
                        tabindex="0"
                        aria-selected="false"
                    >
                        <span>
                            {{ option.label }}
                        </span>
                    </li>

                }

            </ul>

        </div>

    }

</div>